import React from "react";
import { motion } from "framer-motion";

const skills = ({ skill }) => {
  const stacks = skill && skill.stacks;
  return (
    <>
      <motion.div
        className="skill-container"
        id="skills"
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.7 }}
      >
        <div>
          <p>{skill.name}</p>
        </div>
        <div className="stack-tag">
          {stacks.map((stack) => (
            <p>{stack.name} </p>
          ))}{" "}
        </div>
      </motion.div>
    </>
  );
};

export default skills;
